import { Link } from 'react-router-dom';

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 bg-background-50">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="relative rounded-2xl overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Soft%20abstract%20gradient%20with%20warm%20golden%20amber%20tones%2C%20smooth%20flowing%20waves%20and%20organic%20shapes%2C%20minimalist%20luxury%20background%2C%20gentle%20light%20effects%2C%20elegant%20and%20inviting%20atmosphere%2C%20no%20sharp%20edges%2C%20harmonious%20color%20blend&width=1200&height=600&seq=cta-hth-2026&orientation=landscape"
              alt=""
              className="w-full h-full object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-700/90 to-primary-800/80"></div>
          </div>

          <div className="relative z-10 text-center py-14 md:py-20 px-6">
            <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
              准备好开始了吗？
            </h2>
            <p className="text-primary-100 text-sm md:text-base max-w-xl mx-auto mb-8">
              立即注册 qiaojzx.cn，体验一站式综合服务的便捷与高效。免费注册仅需一分钟。
            </p>
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
              <Link
                to="/category/register-login"
                className="w-full sm:w-auto px-8 py-3.5 bg-background-50 text-primary-700 font-medium rounded-lg hover:bg-background-100 transition-all text-base whitespace-nowrap"
              >
                免费注册账户
              </Link>
              <Link
                to="/about"
                className="w-full sm:w-auto px-8 py-3.5 bg-transparent text-background-50 font-medium rounded-lg hover:bg-background-50/10 transition-all text-base border border-background-50/30 whitespace-nowrap"
              >
                了解更多
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}